import { CoreContext } from 'context/CoreContext';
import { useContext } from 'react';
import { Icon, ModalContainer, ModalContent, Overlay, Title } from 'ui/styled';
import { CloseContainer, CompanyDataContainer } from './styled';

export default function Wrapper({
  children,
  onClose,
  title = null,
  className,
  customTitle,
}) {
  const { setModal } = useContext(CoreContext);
  //adiciona funcionalidade de fechar ao clicar fora do modal via prop ou contexto
  const close = () => {
    //agora permti passar via func de fechamento externa
    if (typeof onClose === 'function') {
      onClose();
    } else {
      setModal(null);
    }
  };
  const handleClose = (e) => {
    const mc = document.getElementById('modal-content');
    if (!mc?.contains(e?.target) && !(e?.target.tagName === 'LI')) {
      //Desabilidado funcionalidade de fechar o modal ao clicar fora
      //close();
    }
  };

  return (
    <Overlay onClick={handleClose} className={className}>
      <ModalContainer>
        <ModalContent id="modal-content">
          <CompanyDataContainer>
            <CloseContainer>
              {customTitle ?? (
                <Title nomargin>{title ? title : 'Oferta'}</Title>
              )}
              <Icon icon={'close-big'} pointer={true} onClick={close} />
            </CloseContainer>
            {children}
          </CompanyDataContainer>
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
}
